<template>
	<v-text-field class="ma-0 pa-0 textfield right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"
        hide-details dense solo :placeholder="days[day]"
        :ref="refname" :key="day"
        v-model="inputValue"
        :prefix="prefix"
        @blur="onBlur($event)"
        @change="onChange($event)"
        @keypress="isAllowed($event)"
        autocomplete="off"
    ></v-text-field>
</template>
<script>
export default {
    name: 'DecInput',
    props: ['day', 'prefix', 'refname', 'value'],
    data: () => ({
        days: [null, 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
        inputValue: null,
    }),
    computed: {
    },
    mounted() {
        this.inputValue = this.getInputValue(this.value)
    },
    beforeDestroy() {
        //console.log('DecInput about to be destroyed')
    },
    methods: {
        getNewValue(value) {
            if (!value || value == '') return null
            return parseFloat(value.replace('.', '').replace(',', '.')).toFixed(2)

        },
        getInputValue(value) {
            if (!value || value == '') return null
            return parseFloat(value).toString().replace(',', '').replace('.', ',')
        },
        onBlur(e) {
            this.$emit('changed', this.getNewValue(this.inputValue))
        },
        onChange(e) {
            //console.log('changed:', e)
        },
        isAllowed(e) {
            let char = String.fromCharCode(e.keyCode); // Get the character
            if(/^[0-9\,\-]+$/.test(char)) return true; // Match with regex 
            else e.preventDefault(); // If not match, don't add to input text
        }
    },
	watch: {
		value (val) {
            //console.log('watcher:', val, this.value, typeof(this.value))
            //if(val) this.inputValue = this.getInputValue(this.value)
            this.inputValue = this.getInputValue(this.value)
		},
	},
}
</script>
<style scoped>
.right-aligned >>> input {
    text-align: end;
}
.textfield >>> .v-text-field__slot input {
    color: orange;
}
.textfield >>> .v-text-field__slot input:focus {
    color: orange;
}
.textfield >>> .v-text-field__slot input::placeholder {
    color: #424242;
}
.textfield >>> .v-text-field__prefix {
    color: black;
}

</style>